module.exports = __webpack_public_path__ + "static/media/-ve_heroes.e8005c5e.png";